<div class="container-fluid p-4">
  <div class="card">
    <div class="card-header">
      <h3>User Event Logs</h3>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="book-user" size="lg" [fixedWidth]="true"></fa-icon>
    </div>
    <div class="card-body">
      <div class="container-fluid filter-controls form-group">
        <h4>Filters</h4>
        <div>
          <div class="form-horizontal row my-2 row-fixed">
            <div class="col col-2">Event Type</div>
            <div class="col col-4">
              <select
                class="language-select form-select form-select-sm"
                id="language"
                [(ngModel)]="userUpdates"
                (ngModelChange)="update(50)"
              >
                <option [ngValue]="true">User Updates</option>
                <option [ngValue]="false">Node Updates</option>
              </select>
            </div>
          </div>
          <div class="form-horizontal row my-2 row-fixed">
            <div class="col col-2">Action</div>
            <div class="col col-4">
              <select
                class="language-select form-select form-select-sm"
                id="language"
                [(ngModel)]="filterAction"
                (ngModelChange)="update(50)"
              >
                <option *ngFor="let action of (userUpdates ? userActions : nodeActions)" [value]="action">{{ action ?? '[ all ]' }}</option>
              </select>
            </div>
          </div>
          <div class="form-horizontal row my-2 row-fixed">
            <div class="col col-2">Username</div>
            <div class="col col-4">
              <input class="form-control" type="text" id="filter-text" [(ngModel)]="filterUsername" (ngModelChange)="update(500)" />
            </div>
          </div>
          <div class="form-horizontal row my-2 row-fixed">
            <div class="col col-2">Resource</div>
            <div class="col col-4">
              <input class="form-control" type="text" id="filter-text" [(ngModel)]="filterResource" (ngModelChange)="update(500)" />
            </div>
          </div>
          <div class="form-horizontal row my-2 row-fixed">
            <div class="col col-2">Value</div>
            <div class="col col-4">
              <input class="form-control" type="text" id="filter-text" [(ngModel)]="filterValue" (ngModelChange)="update(500)" />
            </div>
          </div>
          <div class="form-horizontal row my-2 row-fixed">
            <div class="col col-2">
              <label
                class="form-check-label"
                for="include-api"
                ngbTooltip="Include events without explicit user interaction."
                placement="right"
              >
                API Events
              </label>
            </div>
            <div class="col col-4">
              <input
                class="form-check-input me-1"
                type="checkbox"
                id="include-api"
                name="include-api"
                [(ngModel)]="includeApi"
                (click)="update(50)"
              />
            </div>
          </div>
          <div class="form-horizontal row my-2 row-fixed" *ngIf="userUpdates">
            <div class="col col-2">
              <label
                class="form-check-label"
                for="include-users"
                ngbTooltip="Include profile updates performed by regular users (changing their own settings)"
                placement="right"
              >
                User Events
              </label>
            </div>
            <div class="col col-4">
              <input
                class="form-check-input me-1"
                type="checkbox"
                id="include-users"
                name="include-users"
                [(ngModel)]="includeUsers"
                (click)="update(50)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive pt-4" style="overflow-y: auto">
        <table class="table" *ngIf="!error && records?.length">
          <thead>
            <tr class="no-bg">
              <th>Username</th>
              <th>Resource</th>
              <th>Action</th>
              <th>Target</th>
              <th>Timestamp</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let r of records">
              <tr>
                <td>{{ r.username }}</td>
                <td>{{ r.resource }}</td>
                <td>{{ r.action }}</td>
                <td>{{ r.key }}</td>
                <td>{{ r.timestamp | date:dateTimeFormat }}</td>
                <td>
                  <button *ngIf="!r.expand" class="btn btn-sm btn-icon btn-primary" (click)="r.expand = true">
                    <fa-icon [icon]="['fal','chevron-right']" [fixedWidth]="true"></fa-icon>
                  </button>
                  <button *ngIf="r.expand" class="btn btn-sm btn-icon btn-secondary" (click)="r.expand = false">
                    <fa-icon [icon]="['fal','chevron-down']" [fixedWidth]="true"></fa-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="r.expand">
                <td colspan="6">
                  <div class="container">
                    <pre>{{ r.value | json }}</pre>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div *ngIf="!error" class="card-body">
        <div *ngIf="loading" class="text-center">
          <span>Loading...</span>
        </div>
        <div *ngIf="!loading && records?.length === 0">
          <span>No records found.</span>
        </div>
        <div *ngIf="!loading && records?.length">
          <button class="btn btn-primary" (click)="loadMore($event)" [disabled]="loading || !hasMore">Load more</button>
        </div>
      </div>
      <div *ngIf="error">
        <div class="card-body text-danger">
          <span *ngIf="error === 'unsupported'">Not supported on this platform!</span>
          <span *ngIf="error === 'unauthorized'">Insufficient permission!</span>
        </div>
      </div>
    </div>
  </div>
</div>
